<script>
import { PROVIDERS } from '../database.js';
import { onMount} from 'svelte';
import { stripe } from '../stripe.js';
import * as user from '../user.js';
import { firestore, IN_PROD } from '../firebase';
import { replace, push, querystring } from 'svelte-spa-router'
import { FormValidator, InputValidator } from '../form.js';
import Inputmask from 'inputmask';
import ModalDiscount from  './modals/discount.svelte';
import AlternateHeader from './altheader.svelte';
import Button from './button.svelte';

/*
Load cart:
    - If nothing in the cart add the main item (other items later)
    - If something in the cart then ask for an updated price from the server

On server:
    - Look at Checkout document and inspect the items and discounts in it
    - Compute new price and return......

Add Discount:
    - Adding discount should happen on server
    - On success add it to the cart
    - On failure do not add it to the cart









*/

const FORMATTER = new Intl.NumberFormat('en-US', {maximumFractionDigits:2, minimumFractionDigits:2});
function FromPennies(n, sep=true)
{
    if (!n) return '0.00';
    if (sep)
        return FORMATTER.format(n/100);
    return (n/100).toFixed(2);
}

let discountCode = '';

let subTotal = null;
let total = null;
let discountTotal = '';
let discountDesc = '';


let elements = null;
let card = null;
let cardReady = false;
let cardError = '';


$:paymentReady = (cardReady || (checkout && !checkout.paymentRequired));

let formValidator = FormValidator();

function Now()
{
    return new Date().getTime()/1000;
}


let errorMsg = '';
import { curUser } from '../user.js';

let checkout = null;

let discountActive = false;

curUser.subscribe((u) =>
{
    if (u && u.auth)
    {
        RecomputeCheckout();
    }
});

onMount(() =>
{
    window.scrollTo(0, 0);

    let elementStyles = {
        base: {
            iconColor: '#ffffff',
            color: 'rgb(255, 255, 255)',
            fontSize: '12pt',
            fontWeight: '400',

            '::placeholder': {
                color: '#bbbebf'
            }
        },
        invalid: {
            iconColor: '#ffcc00',
            color: '#ffcc00'
        }
    };

    elements = stripe.elements();
    card = elements.create('card', {style:elementStyles});
    card.on('change', function(e) {
        if (e.complete)
        {
            // enable payment button
            cardReady = true;
            cardError = '';
        }
        else if (e.error)
        {
            // show some error text or something
            cardReady = false;

            cardError = e.error.message;
            console.log('error', errorMsg);
        }
        else if (e.ready)
        {

        }

        if (!e.error)
        {
            // clear the error message
            cardError = '';
        }


    });
    card.mount('#card-element');
});

function RemoveDiscount()
{
    total = subTotal = null;

    let prePayReq = paymentRequired;
    CloudCall('removeDiscount', {}).then(res =>
    {
        discountCode = '';
        OnCheckoutUpdated(res);

    })
    .catch((error) =>
    {
        console.log('unexpected err', error);
    })
    .then(() =>
    {
    });
}

function ApplyDiscount()
{
    total = subTotal = null;

    // see if we are applying or removing
    CloudCall('addDiscount', {discountCode}).then(res =>
    {
        OnCheckoutUpdated(res);
    })
    .catch((error) =>
    {
        console.log('unexpected err', error);
    })
    .then(() =>
    {
    });
}

let discountError = false;
let discountModal = null;
function OnApplyDiscount(event)
{
    discountCode = event.detail.code;
    ApplyDiscount();
   // discountModal.Update('foo');
    //const code = event.detail.code;
}


let showingDiscount = true;

function ShowDiscount()
{
    discountModal = ShowModal(ModalDiscount, {}, (closeCode, comp) =>
    {
        // do nothing.....
        discountModal = null;
    },  {apply:OnApplyDiscount});
}



$:paymentRequired = (checkout ? checkout.paymentRequired : true);
$:paymentButtonValue = paymentRequired ? "Pay Now" : "Complete Registration";

function OnCheckoutUpdated(c)
{
    checkout = c;
    console.log('checkout', checkout);

    discountActive = checkout && checkout.discount.valid;
    discountCode = checkout.cart.discount;
    if (discountActive)
    {
        // dismiss the modal
        discountError = false;

        discountDesc = checkout.discount.desc;
    }
    else
    {
        if (checkout && checkout.discount.valid === false)
        {
            discountError = true;
        }
        else
        {
            discountError = false;
        }
    }

    if (discountError)
    {
        //ShowDiscountError();
        if (discountModal)
        {
            discountModal.SetError("Code not valid");
        }
    }
    else
    {
        HideModal(MODAL_OK); // if there is anything showing
    }

    paymentRequired = checkout.paymentRequired;

    subTotal = '$' + FromPennies(checkout.invoice.subtotal) + '/mo';
    total = '$' + FromPennies(checkout.invoice.total);

    if (paymentRequired && checkout.invoice && checkout.invoice.discount_amounts.length)
        discountTotal = '-'+FromPennies(checkout.invoice.discount_amounts[0].amount) + '/mo';
}

function RecomputeCheckout()
{
    total = subTotal = null;

    // for now just hard code the stripe product/price ID here
    //
    let discounts = null;

    if (discountCode)
    {
        discounts = [discountCode];
    }

    let items = ['price_1IDfZUEmGSNW2XQwBbvQE7Hx'];
    if (IN_PROD)
    {
        items = ['price_1IEEPSEmGSNW2XQwp75DC3D2'];
    }


    CloudCall('recomputeCheckout', {discounts, items}).then(res =>
    {
        OnCheckoutUpdated(res);
    })
    .catch((error) =>
    {
        console.log('what is this stupid error', error);
        checkout = null;
    }).
    then(() =>
    {
    });

}


let purchasing = false;

function CompleteSignup(paymentMethodID, paymentInfo)
{
    CloudCall('processPayment', {paymentMethodID, paymentInfo}).then(res =>
    {
        console.log('the result from my cloud call', res);
        if (res.error)
        {
            if (res.error === 'payment-failed')
                cardError = 'Payment Failed. Please try again!';
        }
        else
        {
            // let's them get access to courses
            //replace('/');
            window.location.replace('/'); // do a complete refresh... or maybe we just go straight to courses
        }
    })
    .then(() => {
        purchasing = false;
    });
}

$:subButtonState = purchasing ? 'loading' : '';

function Go()
{
    if (!paymentReady)
    {
        console.log("no go...");
        return;
    }
    purchasing = true

    if (checkout.paymentRequired)
    {
        stripe.createPaymentMethod({
            type: 'card',
            card: card
        })
        .then((result) =>
        {
            console.log('Stripe createPaymentMethod result', result);

            if (result.error)
            {
                // TODO we have lots of error handling to take care of
                console.log(result.error);
            }
            else
            {
                let paymentMethodID = null;
                let paymentInfo = null;

                paymentMethodID = result.paymentMethod.id;
                const pcard = result.paymentMethod.card;
                paymentInfo = {brand:pcard.brand, last4:pcard.last4, exp:`${pcard.exp_month}/${pcard.exp_year}`};

                // assuming this is a card for now
                console.log('payment method', paymentMethodID, paymentInfo);
                CompleteSignup(paymentMethodID, paymentInfo);
            }
        });
    }
    else
    {
        CompleteSignup(null, null);
    }
}




</script>

<AlternateHeader/>

<!-- new section -->
<div class="container main medium" style="margin-top: 0;">
<section class="line-after">
  <header class="major center">
      <div class="image"><img src="images/whiteLogo.png" alt="" /></div>
  </header>
</section>
  <section>
    <header style="padding-left: 1em;">
        <h5>Step 4 of 4</h5>
        <h4>Enter payment information</h4>
    </header>
  </section>
  <section class="border-section">
    <header>
      <h4>YOUR SUBSCRIPTION</h4>
    </header>
    <form action="#" method="post" style="margin: 0;">
      <table style="margin: 0;">
          <tr>
            <th><p>Summit Unlimited</p></th>
            <th>
            {#if subTotal === null}
                <div style="display: inline-block; vertical-align: middle;" class="spinner fit"></div>
            {:else}
                <p style="text-align: right;">{subTotal}</p>
            {/if}
            </th>
          </tr>
          <tr>
              {#if discountActive}
                  <th style="vertical-align: middle; padding: 0 0 2rem 0; color: white; font-weight: normal;"><div>{discountDesc}</div>
                      <a style="color:red; font-weight: normal; font-size:.8rem; padding-left:2px;" href={"javascript:void(0)"} on:click={RemoveDiscount}>Remove</a></th>
            {:else}
              <th style="vertical-align: middle; padding: 0 0 2rem 0;"><a href={"javascript:void(0)"} on:click={ShowDiscount}>Add a discount</a></th>
            {/if}
            {#if discountActive}
                <p style="text-align: right;">{discountTotal}</p>
            {/if}
          </tr>
        </table>
      </form>
  </section>
  <section class="border-section">
    <table style="margin: 0;">
     {#if paymentRequired}
      <tr>
        <th><h4 style="margin-bottom: 0; font-size: 1.15em;">TOTAL DUE TODAY</h4></th>
            <th>
            {#if total === null}
                <div style="display: inline-block; vertical-align: middle;" class="spinner fit"></div>
            {:else}
                <p style="margin: 0; text-align: right;">{total}</p>
            {/if}
            </th>
      </tr>
     {:else}
      <tr>
        <th><h4 style="margin-bottom: 0; font-size: 1.15em;">NO PAYMENT REQUIRED</h4></th>
      </tr>

    {/if}
    </table>
  </section>
    {#if paymentRequired}
  <section class="border-section">
    <header>
      <h4>PAYMENT</h4>
    </header>
      <form on:submit|preventDefault={Go} novalidate>
        <div class="row gtr-uniform">
          <div class="col-12 col-12-xsmall">
            <div id="card-element"></div>
            {#if cardError}
                <div class="error">{cardError}</div>
            {/if}
          </div>
          <div class="col-12 col-12-xsmall">
            <p>By clicking "Agree & Subscribe", you are enrolling in automatic payments of $29.99/month
              that will continue until you cancel.</p>
          </div>
          <div class="col-12 col-12-xsmall">
            <ul class="actions special">
                <li>
                    <Button state={subButtonState} class="button fit" type="submit" text="AGREE & SUBSCRIBE"></Button>
                </li>
            </ul>
          </div>
        </div>
      </form>
  </section>
  {:else}
  <section class="border-section">
    <header>
        <h4>&nbsp;</h4>
    </header>

      <form on:submit|preventDefault={Go} novalidate>
        <div class="row gtr-uniform">
          <div class="col-12 col-12-xsmall">
            <ul class="actions special">
              <li><button class="button fit" type="submit">SUBSCRIBE</button></li>
            </ul>
          </div>
        </div>
      </form>
  </section>

    {/if}
</div>

<style>
@media screen and (max-width: 480px) {
  header.center {
    text-align: center;
}}


div.error
{
    padding-left:2px;
    padding-top:2px;
    color: #ffcc00 !important;
}

#card-element
{
	border-radius: 6px;
	border: solid 1px #e2eaec;
	padding: 1em;
    overflow: hidden;
    max-height: 60px;
}


section.border-section {
  background-color: #4c4c4c;
  border-radius: 4px;
  padding: 1em;
  margin: .5em 0;
}

th {
    padding: 0;
}

tr { padding: 0; }

header.major { margin: 1em 0 0 0; }
.container > section.line-after:after {
  content: '';
  display: inline-block;
  width: 90%;
  height: 0.25rem;
  margin: 1em 5%;
  border-radius: 4px;
  background-color: #4a98e2;
}

@media screen and (max-width: 480px) {
  .container > section.line-after:after {
    width: 100%;
    height: 0.25rem;
    margin: 1em 0;
  }
}

@media screen and (max-width: 736px) {
  .image > img {
    max-width: 90%;
    margin: 0 auto;
  }
}

form a
{
    color: rgb(103, 189, 255);
    border-bottom: 0;
}
.errorMsg
{
    color: red;
    text-align: left;
}

input.error
{
    border-color: red;
    border-width: 2px;
}

.container.medium.main {
  background-color: #1a242f !important;
  padding-top: 0;
  font-size: 13pt;
}

.container.medium.main input {
    background-color: rgb(0 0 0 / .3);
}

.container.medium.main h4, .container.medium.main h6, input, label, p, strong, .button.fit {
  color: #fff !important;
}

h5 {
  color: #c5c5c5 !important;
  font-weight:normal;
}

label {font-weight: 400;}

.container.medium.main {
  width: 500px;
  max-width: 500px;
}

@media screen and (max-width: 736px) {
  .container.medium.main {
    width: 425px;
  }
}

@media screen and (max-width: 480px) {
  .container.medium.main {
    width: 375px;
  }
}

@media screen and (max-width: 320px) {
  .container.medium.main {
    width: 300px;
  }
}


ul.actions.special >li { width: 100%; margin: 0;}

section.special-line {
    -moz-transition: width 0.85s ease;
    -webkit-transition: width 0.85s ease;
    -ms-transition: width 0.85s ease;
    transition: width 0.85s ease;
    -moz-transition-delay: 0.25s;
    -webkit-transition-delay: 0.25s;
    -ms-transition-delay: 0.25s;
    transition-delay: 0.25s;
    background: #fff;
    content: '';
    display: block;
    height: 2px;
    position: absolute;
    width: 500px;
}

</style>
